import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

// // state: 存储数据
// const state = {};
// // mutations: 修改state数据
// const mutations = {};
// // actions: 书写业务逻辑 处理异步 不能修改state
// const actions = {}
// //getters: 类似计算属性，简化仓库数据 
// const getters = {}
// // 对外暴露stroe实例
// export default new Vuex.Store({
//     state,
//     mutations,
//     actions,
//     getters
// })
import dict from "./api/dict.js"
import commons from "./api/commons.js"
import temple from "./api/temple.js"
export default new Vuex.Store({
    modules: {
        dict,
        commons,
        temple
        // home,
        // search,
        // detail
    }
})